import { Navigate } from '@tanstack/react-router';
import { useState } from 'react';
import { ErrorNotice } from '../components/Notice.tsx';
import { IconCredit, LegalLinks, Masthead } from '../components/Layout.tsx';
import { Icon } from '../components/Icon.tsx';
import { UI } from '../icons/ui-icons.ts';
import { rt } from '../lib/runtime.ts';
import { useMe } from '../lib/useMe.ts';

export function Landing() {
  const auth = rt().auth;
  const [signedIn, setSignedIn] = useState(auth.isSignedIn());
  if (signedIn) return <SignedInRedirect />;
  return (
    <div className="mx-auto flex min-h-dvh max-w-xl flex-col justify-center gap-8 px-4 py-12">
      <Masthead />
      <div className="space-y-4 text-lg leading-relaxed">
        <p>
          A realm of four towns, sixteen trades and a great many knives in the dark. Train at the yard, work the venues,
          ride the roads, trade in the market and settle your quarrels in the street.
        </p>
        <p className="text-ink-dim">Your bars refill while you are away. The clock is the same for everyone.</p>
      </div>
      <SignIn onSignedIn={() => setSignedIn(true)} />
      <footer className="flex flex-wrap gap-3 text-xs text-ink-faint"><LegalLinks /><IconCredit /></footer>
    </div>
  );
}

function SignIn({ onSignedIn }: { onSignedIn: () => void }) {
  const auth = rt().auth;
  const [handle, setHandle] = useState('');
  const [error, setError] = useState<unknown>(null);
  if (auth.mode === 'cognito')
    return (
      <div>
        <button type="button" className="btn text-lg" onClick={() => auth.signIn().catch(setError)}>
          Enter the realm →
        </button>
        <ErrorNotice error={error} />
      </div>
    );
  return (
    <form
      className="panel space-y-3"
      onSubmit={(e) => {
        e.preventDefault();
        auth.signIn(handle).then(onSignedIn, setError);
      }}
    >
      <label className="block space-y-1">
        <span className="smallcaps text-sm text-ink-dim">Local sign-in · any handle</span>
        <input className="field w-full" value={handle} onChange={(e) => setHandle(e.target.value)} placeholder="e.g. alice" autoFocus />
      </label>
      <button className="btn" type="submit">Enter the realm →</button>
      <ErrorNotice error={error} />
    </form>
  );
}

function SignedInRedirect() {
  const me = useMe();
  if (me.isPending) return <Loading />;
  if (me.error) return <div className="p-8"><ErrorNotice error={me.error} /></div>;
  // A steward with no character of their own goes straight to the stewards' view.
  return <Navigate to={me.data.player ? '/town' : me.data.isAdmin ? '/admin' : '/create'} />;
}

export function Loading() {
  return <div className="flex min-h-dvh items-center justify-center text-ink-faint"><Icon name={UI.loading} className="mr-1" />…</div>;
}
